export default "__VITE_ASSET__DaInASMJ__"